<bw-modal-legacy [fullContentWidth]="true" [showCloseButton]="false" modalWidth="medium">
  <div id="dvModalRouterOutletWrapper" class="body">
    <router-outlet></router-outlet>
  </div>
</bw-modal-legacy>

